import { RandomGenerator } from "../../../test-utils";
var ExternalEscalationProviderBuilder = /** @class */ (function () {
    function ExternalEscalationProviderBuilder() {
        this.externalEscalationProvider = {
            id: RandomGenerator.id(),
            name: RandomGenerator.randomName(),
            icon: RandomGenerator.randomString()
        };
    }
    ExternalEscalationProviderBuilder.prototype.withId = function (id) {
        this.externalEscalationProvider.id = id;
        return this;
    };
    ExternalEscalationProviderBuilder.prototype.withName = function (name) {
        this.externalEscalationProvider.name = name;
        return this;
    };
    ExternalEscalationProviderBuilder.prototype.withIcon = function (icon) {
        this.externalEscalationProvider.icon = icon;
        return this;
    };
    ExternalEscalationProviderBuilder.prototype.build = function () {
        return this.externalEscalationProvider;
    };
    return ExternalEscalationProviderBuilder;
}());
export { ExternalEscalationProviderBuilder };
;
//# sourceMappingURL=external-escalation-provider.builder.js.map